<template lang="pug">
	sfc-modal(id="sfc-onboarding-modal-v3-2" title="" @close="closeModal" @open="openModal(); showModal();")
		h2.title
			| {{title}}
		.completion-progress
			.progress(:style="`width: ${progressLength}%`")

		div(:key="enableModals")
			sfc-do-you-have-an-account(@next="next" v-show="currentComponent == 'sfc-do-you-have-an-account'")
			sfc-what-is-your-state-of-residence(@next="next" v-show="currentComponent == 'sfc-what-is-your-state-of-residence'")
			sfc-who-are-you-saving-for(@next="next" :with-back-button="backButton" v-show="currentComponent == 'sfc-who-are-you-saving-for'")
			sfc-how-old-is-your-child(@next="next" v-show="currentComponent == 'sfc-how-old-is-your-child'" @title-update="titleUpdate")
			sfc-how-can-we-help-you-today(@next="next" v-show="currentComponent == 'sfc-how-can-we-help-you-today'")
			sfc-create-your-account(@next="next" v-show="currentComponent == 'sfc-create-your-account'")

			sfc-college-savings-gifting(@next="next" v-show="currentComponent == 'sfc-college-savings-gifting'")
			sfc-college-savings-journey(@next="next" v-show="currentComponent == 'sfc-college-savings-journey'")

			sfc-log-in-to-your-account(@next="next" v-show="currentComponent == 'sfc-log-in-to-your-account'")
			sfc-forgot-your-password(@next="next" v-show="currentComponent == 'sfc-forgot-your-password'")
</template>

<style lang="stylus">
@import '~assets/css/variables.styl'

#sfc-onboarding-modal-v3
	.radio-wrap
		margin-top 20px

	.modal-content
		.modal-body
			padding 40px
	.text-input
		.tb
			box-shadow: inset 0 1px 3px 0 rgba(101, 116, 134, 0.05);
			border 1px solid sfc-gray-dark
	h3
		margin-top 10px
		font-size: body-font-size-lg
		margin-bottom 30px
	ul
		padding 0
		margin 0
		list-style none
		li
			margin-bottom 30px

	.bordered-left
		border-left 1px solid sfc-pale-gray
	.link
		color #2486e7

	.cursor-pointer
		cursor pointer
	.close-in-word
		cursor pointer
		font-size: body-font-size
		top -25px
		right 0px
		position absolute
		color: #fff
</style>

<script>

import SfcWhoAreYouSavingFor from '@/common/components/savings-center/v3/onboarding/who-are-you-saving-for'
import SfcHowOldIsYourChild from '@/common/components/savings-center/v3/onboarding/how-old-is-your-child'
import SfcHowCanWeHelpYouToday from '@/common/components/savings-center/v3/onboarding/how-can-we-help-you-today'
import SfcCreateYourAccount from '@/common/components/savings-center/v3/onboarding/create-your-account'
import SfcLogInToYourAccount from '@/common/components/savings-center/v3/onboarding/log-in-to-your-account'
import SfcForgotYourPassword from '@/common/components/savings-center/v3/onboarding/forgot-your-password'
import SfcWhatIsYourStateOfResidence from '@/common/components/savings-center/v3/onboarding/what-is-your-state-of-residence'
import SfcDoYouHaveAnAccount from '@/common/components/savings-center/v3/onboarding/do-you-have-an-account'
import SfcCollegeSavingsJourney from '@/common/components/savings-center/v3/onboarding/college-savings-journey'
import SfcCollegeSavingsGifting from '@/common/components/savings-center/v3/onboarding/college-savings-gifting'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	props: {
		savingsCenterFlow:{
			default: false
		},
		value:{
			default: true
		}
	},

	components: {
		SfcWhoAreYouSavingFor,
		SfcHowOldIsYourChild,
		SfcHowCanWeHelpYouToday,
		SfcCreateYourAccount,
		SfcLogInToYourAccount,
		SfcForgotYourPassword,
		SfcWhatIsYourStateOfResidence,
		SfcDoYouHaveAnAccount,
		SfcCollegeSavingsJourney,
		SfcCollegeSavingsGifting
	},

	data() {
		return {
			progressLength: 0,
			progressStep: 10,
			title: "Who are you saving for?",
			currentComponent: "sfc-who-are-you-saving-for",
			lastComponent: false,
			enableModals: false,
			mode: 'default', // Used for progress bar
			backButton: false
		}
	},

	methods: {

		openModal(){

			if(this.$sfcModal.params && this.$sfcModal.params.savingsCenterFlow){
				this.progressLength = 0
				this.title = "What is your state of residence?"
				this.currentComponent = "sfc-what-is-your-state-of-residence"
				this.mode = 'savings-center'
				this.backButton = true
			}else{
				if(!this.$store.state.collegeSavingsUserOnboarding["state"]){
					this.progressLength = 0
					this.title = "What is your state of residence?"
					this.currentComponent = "sfc-what-is-your-state-of-residence"
					this.mode = 'state'
					this.backButton = true
				}
			}

			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "What is your state of residence? - shown", "", 0)

			this.enableModals = true
			this.setProgressBarLength(this.currentComponent)
		},

		async showModal(){
			const tokenSavingsCenterInfo = this.$cookies.get("savings-center-info")
			if (tokenSavingsCenterInfo){
				this.closeModal()
				return window.location.href = '/savings-center/' + tokenSavingsCenterInfo["next_step_v3"]
			}

			const token = this.$cookies.get("sfc_primary")
			let collegeSavingsUser = undefined
			const query = `
				query{
					no_graphql_cache()
					college_savings_user_v3(sfc_token: "${token}"){
						id
						next_step_v3
						type_of_user
						children{
							id
							name
							age
						}
						state{
							id
							name
							slug
						}
						email
						primary_id
					}
				}
			`

			try {
				const result = await this.$httpService.graphql(query)
				collegeSavingsUser = result.data.college_savings_user_v3
			} catch (e) {
				collegeSavingsUser = undefined
			}

			if(collegeSavingsUser && collegeSavingsUser.next_step_v3){
				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: collegeSavingsUser.next_step_v3})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "type_of_user", value: collegeSavingsUser.type_of_user})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "children", value: collegeSavingsUser.children})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "state", value: collegeSavingsUser.state})

				this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "email", value: collegeSavingsUser.email})

				const collegeSavingsUserString = JSON.stringify(collegeSavingsUser)
				this.$cookies.set("savings-center-info", collegeSavingsUserString, {
					maxAge: 365 * 24 * 60 * 60
				})

				return this.$router.push({path: "/savings-center/" + collegeSavingsUser.next_step_v3})
			}
		},

		closeModal(){
			this.progressLength = 25
			this.title = "Who are you saving for?",
			this.currentComponent = "sfc-who-are-you-saving-for"
			this.enableModals = false
			setTimeout(()=>{
				this.enableModals=true
			}, 300)
		},
		titleUpdate(title){
			this.title = title
		},
		setProgressBarLength(step){
			const steps = ['sfc-do-you-have-an-account', 'sfc-what-is-your-state-of-residence', 'sfc-who-are-you-saving-for', 'sfc-college-savings-journey', 'sfc-college-savings-gifting', 'sfc-how-old-is-your-child', 'sfc-how-can-we-help-you-today', 'sfc-create-your-account', 'sfc-log-in-to-your-account', 'sfc-forgot-your-password']

			const indexOfStep = steps.indexOf(step)

			if(indexOfStep < 2){
				this.progressLength = 0
				return
			}

			let factor = 15
			let stepJump = 1
			const progress = (indexOfStep - stepJump) * factor

			if(step == 'sfc-create-your-account'){
				this.progressLength = 100
				return
			}

			if(this.mode == 'default'){
				factor = 35
				stepJump = 2
			}

			if(progress > 100){
				this.progressLength = 100
			}else{
				this.progressLength = progress
			}

		},
		next(progressLength, title, component, lastComponent = false, recoverHistory = false){

			if (lastComponent){
				this.lastComponent = lastComponent
			}

			if (recoverHistory && this.lastComponent){
				this.title = this.lastComponent.title
				this.currentComponent = this.lastComponent.component
				this.lastComponent = false
			}else{
				this.title = title
				this.currentComponent = component
			}

			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", title +" - shown", "", 0)

			this.setProgressBarLength(component)
		}
	}

}
</script>
